import { DOMAIN_BUNDLES } from '@/domains'
import { requiresProductProblem } from '@/sdk/contract'
import * as tenantPlugin from '@tenant/plugin'

import { activeDomainBundles } from './bundles'
import { applyTenantPlugin } from './slots'

const tenantExports: Record<string, unknown> = tenantPlugin

const contractProblem = requiresProductProblem(tenantPlugin.requiresProduct)
if (contractProblem) {
  console.warn(`[labs] tenant pack: ${contractProblem}`)
}

for (const [, register] of activeDomainBundles(DOMAIN_BUNDLES, tenantExports['providesDomains'])) {
  applyTenantPlugin(register)
}
applyTenantPlugin(tenantPlugin.register)

export { getPluginSlots } from './slots'
